<template>
  <div id="overlay" data-overlay></div>
</template>

<script>
export default {
    name: "Overlay"
}
</script>